export default __webpack_public_path__ + "static/media/Roano_R2.78f378ed.jpg";